/**
 * The reference files a retailer's transaction preprocessing reads alongside the transaction file
 * itself. Each pipeline declares which of these it needs; see the import-prep pipeline registry.
 */
export enum ImportMappingType {
  Adjustments = 'adjustments',
  CategoryMapping = 'category mapping',
  IgnoredCustomers = 'ignored customers',
  UomMapping = 'uom mapping',
}
